import FileApi from '@/services/files/index'
import { mapActions } from 'vuex'

export const methods = {
  ...mapActions('template', ['errorMessage']),
  ...mapActions('agendamentos', [
    'updateAtributoAgendamento',
    'enviarAgendamento',
    'enviarAnexos',
  ]),
  //
  // --- ENVIA LISTA DE KEYS PRO BACKEND ---
  //
  async setDocs(docs) {
    this.documentosNome = docs
    try {
      const data =await this.enviarAnexos({
        agendamento: this.agendamento,
        anexos: docs,
      })
      this.documentosList = []
      this.documentos = []

      this.updateAtributoAgendamento({
        valor: data.anexos,
        nomeAtributo: 'anexos',
      })
      this.carregaAnexos()

    } catch (error) {
      this.errorMessage(
        error?.response?.data ||
          error?.message ||
          'Erro ao salvar anexos no agendamento.'
      )
    }
  },

  //
  // --- ENVIO DE ARQUIVOS PARA O BACKEND ---
  //
  async sendDocs() {
    const documentos = this.documentosList
    let names = []
    let errors = {}

    await Promise.all(
      documentos.map(async (doc) => {
        // documentos já existentes (backend)
        if (!doc.necessity_send) {
          names.push(doc.attachment_key)
          return
        }

        // novos arquivos só ficam no this.files
        const file = this.files.find((f) => f.id === doc.id)
        if (!file) return

        const formData = new FormData()
        formData.append('description', doc.description)
        formData.append('file', file)

        try {
          const data = await FileApi.postAnexosAgendamento(formData)
          if (data.attachment_key) {
            names.push(data.attachment_key)
            doc.necessity_send = false
            doc.attachment_key = data.attachment_key
          }
        } catch (error) {
          errors[doc.description] =
            error?.response?.data ||
            error?.message ||
            'Erro desconhecido ao enviar arquivo.'
        }
      })
    )

    if (Object.keys(errors).length) {
      return this.errorMessage(errors)
    }

    await this.setDocs(names)


  },

  carregaAnexos(){
    this.documentos = this.agendamento.anexos
      ? this.agendamento.anexos.map((doc) => {
          return { ...doc, necessity_send: false }
        })
      : []
    this.documentosList = [...this.documentos]
  },
  //
  // --- EXCLUIR DOCUMENTO ---
  //
  excluirDocumento(documento) {
    const idxList = this.documentosList.findIndex((d) => d.id === documento.id)
    const idxFiles = this.files.findIndex((f) => f.id === documento.id)

    if (idxList > -1) this.documentosList.splice(idxList, 1)
    if (idxFiles > -1) this.files.splice(idxFiles, 1)

    this.$emit('remove-documento', documento)
  },

  changeArquivo(e) {
    const files = Array.from(e.target.files)
    if (!files.length) return

    files.forEach((file) => {
      this.documento_id++

      // adiciona no array de exibição
      this.documentosList.push({
        id: this.documento_id,
        description: file.name,
        necessity_send: true,
      })

      // salva o FILE real
      const fileClone = file
      fileClone.id = this.documento_id
      this.files.push(fileClone)
    })

    e.target.value = ''
    this.sendDocs()
  },

  abrirArquivo() {
    this.$refs.file.click()
  },

  open(item) {
    if (item.url) window.open(item.url, '_blank')
  },
}
